<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style>
.noty_theme__metroui.noty_type__success {
  background-color: #627F8B;
}
.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.fadeIn {
  -webkit-animation-name: fadeIn;
  animation-name: fadeIn;
}

@-webkit-keyframes fadeOut {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

.fadeOut {
  -webkit-animation-name: fadeOut;
  animation-name: fadeOut;
}

.outer-chart-wrap .movie-panel {
  float: left;
  width: 358px;
  text-align: left;
  margin-top: 5px;
  position: relative;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2C3E50;
}
@media only screen and (max-width: 767px) {
  #app * {
    font-weight: normal;
  }
}
.fal {
  font-weight: 300!important;
}
#app, .pure-g [class*=pure-u], .grape .grape-content, .grape .grape-content span, .grape .grape-content p, .ui-widget, .ui-widget input, .ui-widget select, .ui-widget textarea, .ui-widget button, .context-menu-item, .pure-button {
  font-family: 'PT Sans', Candara, Segoe, "Segoe UI", Optima, Arial, sans-serif;
}
.group:before,
.group:after {
  content: "";
  display: table;
} 
.group:after {
  clear: both;
}
.group {
  zoom: 1; /* For IE 6/7 (trigger hasLayout) */
}
#video-overlay {
    position: fixed;
    background: rgba(0,0,0,0.8);
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    z-index: 999;
    overflow: hidden;
    padding: 5vh 0;
    bottom: 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  #video-overlay > .container {
    width: 1000px;
    max-width: 80%;
    height: auto;
    background: #fff;
    margin: 0 auto;
    padding: 0;
    top: 50%;
    transform: translateY(-50%);
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    position: relative;
  }
  #video-overlay .modal-close {
    position: absolute;
    top: -40px;
    right: -40px;
    width: 38px;
    font-size: 32px;
    color: #fff;
  }
  #video-overlay .modal-close:hover {
    opacity: 0.6;
  }
  .video-wrap {
    position: relative;
    padding-bottom: 56.25%; /* 16:9 */
    padding-top: 25px;
    height: 0;
  }
  .video-wrap:empty {
    display: none;
  }
    .video-wrap iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%!important;
    height: 100%!important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue